






import { Component } from "vue-property-decorator";
import { DropdownBase } from "./dropdown-base"

@Component({})

export default class DropdownMenu extends DropdownBase {
  opened = true;
}

